import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { RefresherCustomEvent } from "@ionic/angular";
import { Subject } from "rxjs";
import { filter, takeUntil } from "rxjs/operators";
import { DataService } from "src/app/shared/components/shared/dataservice";
import { Edge, EdgeConfig, EdgePermission, Service, Utils, Websocket, Widgets } from "src/app/shared/shared";

@Component({
  selector: "live",
  templateUrl: "./live.component.html",
  styleUrls: ["./live.component.scss"],
})
export class LiveComponent implements OnInit, OnDestroy {

  public edge: Edge | null = null;
  public config: EdgeConfig | null = null;
  public widgets: Widgets | null = null;
  protected isModbusTcpWidgetAllowed: boolean = false;
  private stopOnDestroy: Subject<void> = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private router: Router, // oEMS
    public service: Service,
    protected utils: Utils,
    protected websocket: Websocket,
    private dataService: DataService,
  ) { }

  public ngOnInit() {
    this.service.currentEdge.subscribe((edge) => {
      this.edge = edge;
      this.isModbusTcpWidgetAllowed = EdgePermission.isModbusTcpApiWidgetAllowed(edge);
    });
    // oEMS Start
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      takeUntil(this.stopOnDestroy),
    ).subscribe(() => {
      this.updateConfig();
    });

    // Initial fetch of config
    this.updateConfig();
    // oEMS End
  }

  public ngOnDestroy() {
    this.stopOnDestroy.next();
    this.stopOnDestroy.complete();
  }

  protected handleRefresh: (ev: RefresherCustomEvent) => void = (ev: RefresherCustomEvent) => this.dataService.refresh(ev);

  // oEMS method
  private updateConfig(): void {
    this.service.getConfig().then(config => {
      this.config = config;
      this.widgets = config.widgets;
    });
  }
}
